import { render, staticRenderFns } from "./groupindex.vue?vue&type=template&id=32307438&scoped=true&"
import script from "./groupindex.vue?vue&type=script&lang=js&"
export * from "./groupindex.vue?vue&type=script&lang=js&"
import style0 from "./groupindex.vue?vue&type=style&index=0&id=32307438&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32307438",
  null
  
)

export default component.exports